import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

interface PhoneNumber {
  phone_number_id: string
  alias: string
  default: boolean
  transport?: 'meta' | 'ultramsg' | 'evolution'
  /** An Evolution line's name, as set on the Lines page. */
  label?: string | null
  /** Human name of the method, e.g. "UltraMsg (linked phone)". */
  method?: string
  /** The real number, as the provider reports it. Null if the lookup failed. */
  display_phone_number?: string | null
  verified_name?: string | null
}

type QueryResponse = {
  timestamp: string;
  status: number;
  data: PhoneNumber[];
};

export const createListNumbersKey = (additional: any[] = []) => [
  'list-numbers',
  ...additional,
];

type LinkedStatusResponse = {
  status: number;
  data: { status?: { accountStatus?: { status?: string; substatus?: string } } };
};

/** Whether the UltraMsg number's WhatsApp session is still linked. */
export const useUltramsgStatusQuery = (enabled: boolean) => {
  const queryFn = useGetQueryFn<LinkedStatusResponse>({
    defaultErrorMessage: 'An unexpected error occurred while checking the UltraMsg session',
    endpoint: `/api/admin/whatsapp/numbers/ultramsg/quality`,
  });

  return useQuery({
    queryKey: createListNumbersKey(['ultramsg-status']),
    queryFn: () => queryFn(),
    enabled,
    retry: false,
  });
};

export const useListNumbersQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while Listing WhatsApp Numbers',
    endpoint: `/api/admin/whatsapp/numbers`,
  });

  return useQuery({
    queryKey: createListNumbersKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};